import { User } from "../../../commons/auth";

export class PlanoPolicy {
  view(user: User, context?: any){
    return true
  }
  register(user: User, context?: any){
    return true
  }
}